import { Component, computed, inject, input, output } from "@angular/core";
import { NgClass } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { TranslatePipe } from "@ngx-translate/core";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "portal-nav-bar",
  templateUrl: "./nav-bar.component.html",
  standalone: true,
  imports: [NgClass, FormsModule, TranslatePipe],
  styleUrls: ["./nav-bar.component.scss"],
})
export class NavBarComponent {
  navbarOpen = false;
  readonly #sanitizer = inject(DomSanitizer);
  readonly notificationUrl = input<string>("");
  readonly myDataUrl = input<string>("");
  readonly showRightMenu = input<boolean>(true);
  readonly backLabel = input<string>("zurück zum g.a.s.t. Dashboard");
  readonly isOverview = input<boolean>(false);
  readonly products = input<string[]>([]);
  readonly selectedProduct = input<string>("");
  readonly showNavBar = input<boolean>(true);

  readonly sanitizedNotificationUrl = computed(() => this.#sanitizer.bypassSecurityTrustUrl(this.notificationUrl()));
  readonly sanitizedMyDataUrl = computed(() => this.#sanitizer.bypassSecurityTrustUrl(this.myDataUrl()));

  readonly showProductsDropdown = computed(() => {
    return this.products()?.length > 1;
  });

  readonly backClicked = output<void>();
  readonly productSelected = output<string>();

  toggleNavbar() {
    this.navbarOpen = !this.navbarOpen;
  }

  onBackClicked() {
    this.backClicked.emit();
  }

  onProductSelected(product: string): void {
    this.productSelected.emit(product);
  }
}
